module.exports = "app-banner{background-color:#d3d3d3; width: 100%; float: left}\napp-gen-info{padding-bottom: 50px; width: 100%; float: left}\napp-gen-ads{width: 100%; float: left}\n/* app-services{width: 100%; float: left;background-image: url(\"assets/banner.jpg\")} */\n/* app-services{width: 100%; float: left; background-color: #f5f6f5} */\napp-services{width: 100%; float: left; background-color: #FFFFFF}"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.css
// module id = ./src/app/home/home.component.css
// module chunks = main